import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export default function FlyashIcon(props: SvgIconProps) {
  return (
    <svg width={281} height={281} viewBox="0 0 281 281" fill="none">
      <rect
        x="1.5"
        y="1.5"
        width={278}
        height={278}
        rx="8.5"
        fill="url(#paint0_linear_225_86899)"
        stroke="white"
        strokeWidth={3}
      />
      <path
        d="M101.569 216.211L104.944 216.211L104.944 230.93L114.788 230.93L114.788 237.352C116.913 235.602 118.991 233.711 121.022 231.68L123.413 234.352C121.163 235.914 118.975 237.414 116.85 238.852C119.444 239.914 121.944 241.039 124.35 242.227L122.616 245.367C120.303 243.898 117.757 242.383 114.975 240.82C115.35 244.227 116.257 246.648 117.694 248.086C119.382 249.773 120.975 250.617 122.475 250.617C123.475 250.617 124.194 250.086 124.632 249.023C125.163 247.555 125.616 245.742 125.991 243.586C127.241 244.18 128.382 244.648 129.413 244.992C128.944 247.023 128.428 248.82 127.866 250.383C126.866 252.852 125.1 254.086 122.569 254.086C120.007 254.086 117.663 253.023 115.538 250.898C112.788 248.148 111.413 243.492 111.413 236.93L111.413 234.117L104.944 234.117L104.944 254.18L101.569 254.18L101.569 234.117L94.069 234.117C93.694 241.773 90.9596 248.32 85.8659 253.758C84.7409 253.008 83.6628 252.383 82.6315 251.883C87.6628 246.789 90.3347 240.867 90.6472 234.117L83.194 234.117L83.194 230.93L90.8347 230.93C90.8659 229.898 90.8815 228.789 90.8815 227.602L90.8815 222.258C89.2878 222.383 87.6003 222.508 85.819 222.633C85.4753 221.383 85.1315 220.352 84.7878 219.539C89.444 219.258 93.9909 218.852 98.4284 218.32L99.7409 221.32C98.0847 221.508 96.2722 221.711 94.3034 221.93L94.3034 227.602C94.3034 228.758 94.2878 229.867 94.2565 230.93L101.569 230.93L101.569 216.211ZM84.5065 214.617L84.5065 211.43L115.069 211.43L115.069 215.789C117.132 214.102 119.085 212.336 120.928 210.492L123.319 213.164C121.538 214.445 119.303 215.977 116.616 217.758C119.303 218.914 121.85 220.086 124.257 221.273L122.522 224.367C120.053 222.773 117.6 221.289 115.163 219.914C115.444 222.445 116.132 224.258 117.225 225.352C119.007 227.133 120.663 228.023 122.194 228.023C123.319 228.023 124.085 227.383 124.491 226.102C124.897 224.852 125.319 223.055 125.757 220.711C126.819 221.242 127.928 221.711 129.085 222.117C128.366 225.086 127.803 227.023 127.397 227.93C126.335 230.305 124.663 231.492 122.382 231.492C119.757 231.492 117.225 230.273 114.788 227.836C112.725 225.773 111.694 222.242 111.694 217.242L111.694 214.617L84.5065 214.617ZM148.879 214.477L158.863 214.477C158.988 212.43 159.051 210.32 159.051 208.148L162.801 208.148C162.801 210.32 162.738 212.43 162.613 214.477L192.379 214.477L192.379 217.898L162.379 217.898C161.113 232.352 156.879 243.617 149.676 251.695C148.957 250.758 148.113 249.742 147.145 248.648C153.567 241.352 157.387 231.102 158.606 217.898L148.879 217.898L148.879 214.477ZM156.473 251.039C167.473 246.82 173.098 239.461 173.348 228.961C173.442 226.461 173.488 223.32 173.488 219.539L177.192 219.539C177.192 222.43 177.145 226.039 177.051 230.367C180.41 241.195 186.02 247.93 193.879 250.57C193.223 251.445 192.442 252.555 191.535 253.898C184.176 251.18 178.902 245.328 175.715 236.344C173.809 244.484 168.176 250.43 158.817 254.18C158.098 253.055 157.317 252.008 156.473 251.039ZM180.754 235.477C183.16 232.102 185.348 228.633 187.317 225.07L190.551 226.945C188.238 230.727 185.926 234.18 183.613 237.305L180.754 235.477ZM161.723 227.461L164.723 225.773C166.317 228.461 168.113 231.711 170.113 235.523L166.926 237.398C164.957 233.305 163.223 229.992 161.723 227.461Z"
        fill="white"
      />
      <path
        d="M113.754 123.466C120.111 123.466 125.264 118.313 125.264 111.956C125.264 105.599 120.111 100.445 113.754 100.445C107.397 100.445 102.243 105.599 102.243 111.956C102.243 118.313 107.397 123.466 113.754 123.466Z"
        fill="white"
      />
      <path
        d="M150.341 153.383C158.613 153.383 165.319 146.677 165.319 138.404C165.319 130.132 158.613 123.426 150.341 123.426C142.068 123.426 135.362 130.132 135.362 138.404C135.362 146.677 142.068 153.383 150.341 153.383Z"
        fill="white"
      />
      <path
        d="M140.776 186.778C145.9 186.778 150.053 182.624 150.053 177.5C150.053 172.376 145.9 168.223 140.776 168.223C135.652 168.223 131.498 172.376 131.498 177.5C131.498 182.624 135.652 186.778 140.776 186.778Z"
        fill="white"
      />
      <path
        d="M150.055 59.123C152.324 59.123 154.163 57.2836 154.163 55.0146C154.163 52.7456 152.324 50.9062 150.055 50.9062C147.786 50.9062 145.946 52.7456 145.946 55.0146C145.946 57.2836 147.786 59.123 150.055 59.123Z"
        fill="white"
      />
      <path
        d="M134.878 88.7402C137.147 88.7402 138.986 86.9008 138.986 84.6318C138.986 82.3628 137.147 80.5234 134.878 80.5234C132.609 80.5234 130.77 82.3628 130.77 84.6318C130.77 86.9008 132.609 88.7402 134.878 88.7402Z"
        fill="white"
      />
      <path
        d="M154.78 40.2566C155.958 40.2566 156.914 39.3011 156.914 38.1224C156.914 36.9438 155.958 35.9883 154.78 35.9883C153.601 35.9883 152.646 36.9438 152.646 38.1224C152.646 39.3011 153.601 40.2566 154.78 40.2566Z"
        fill="white"
      />
      <path
        d="M172.386 88.9709C177.655 88.9709 181.926 84.6997 181.926 79.4308C181.926 74.1619 177.655 69.8906 172.386 69.8906C167.117 69.8906 162.846 74.1619 162.846 79.4308C162.846 84.6997 167.117 88.9709 172.386 88.9709Z"
        fill="white"
      />
      <path
        d="M84.3771 98.6233C89.646 98.6233 93.9172 94.352 93.9172 89.0831C93.9172 83.8142 89.646 79.543 84.3771 79.543C79.1082 79.543 74.8369 83.8142 74.8369 89.0831C74.8369 94.352 79.1082 98.6233 84.3771 98.6233Z"
        fill="white"
      />
      <path
        opacity="0.5"
        d="M125.263 46.2668C128.582 46.2668 131.273 43.5763 131.273 40.2574C131.273 36.9385 128.582 34.248 125.263 34.248C121.944 34.248 119.254 36.9385 119.254 40.2574C119.254 43.5763 121.944 46.2668 125.263 46.2668Z"
        fill="white"
      />
      <path
        d="M202.768 100.933C204.865 100.933 206.565 99.2333 206.565 97.1365C206.565 95.0396 204.865 93.3398 202.768 93.3398C200.671 93.3398 198.972 95.0396 198.972 97.1365C198.972 99.2333 200.671 100.933 202.768 100.933Z"
        fill="white"
      />
      <path
        d="M113.755 93.1126C120.112 93.1126 125.265 87.9592 125.265 81.6022C125.265 75.2452 120.112 70.0918 113.755 70.0918C107.398 70.0918 102.244 75.2452 102.244 81.6022C102.244 87.9592 107.398 93.1126 113.755 93.1126Z"
        fill="white"
      />
      <path
        d="M108.897 164.895C117.169 164.895 123.875 158.189 123.875 149.916C123.875 141.644 117.169 134.938 108.897 134.938C100.624 134.938 93.918 141.644 93.918 149.916C93.918 158.189 100.624 164.895 108.897 164.895Z"
        fill="white"
      />
      <path
        opacity="0.5"
        d="M88.5326 176.782C93.6565 176.782 97.8103 172.628 97.8103 167.504C97.8103 162.38 93.6565 158.227 88.5326 158.227C83.4086 158.227 79.2549 162.38 79.2549 167.504C79.2549 172.628 83.4086 176.782 88.5326 176.782Z"
        fill="white"
      />
      <path
        d="M193.067 114.381C195.336 114.381 197.176 112.541 197.176 110.272C197.176 108.003 195.336 106.164 193.067 106.164C190.798 106.164 188.959 108.003 188.959 110.272C188.959 112.541 190.798 114.381 193.067 114.381Z"
        fill="white"
      />
      <path
        d="M97.8099 177.452C100.079 177.452 101.919 175.612 101.919 173.343C101.919 171.074 100.079 169.234 97.8099 169.234C95.5407 169.234 93.7012 171.074 93.7012 173.343C93.7012 175.612 95.5407 177.452 97.8099 177.452Z"
        fill="white"
      />
      <path
        d="M212.498 126.573C213.677 126.573 214.633 125.617 214.633 124.439C214.633 123.26 213.677 122.305 212.498 122.305C211.32 122.305 210.364 123.26 210.364 124.439C210.364 125.617 211.32 126.573 212.498 126.573Z"
        fill="white"
      />
      <path
        opacity="0.5"
        d="M162.846 134.965C168.115 134.965 172.386 130.694 172.386 125.425C172.386 120.156 168.115 115.885 162.846 115.885C157.577 115.885 153.306 120.156 153.306 125.425C153.306 130.694 157.577 134.965 162.846 134.965Z"
        fill="white"
      />
      <path
        d="M88.795 62.0315C94.0639 62.0315 98.3352 57.7602 98.3352 52.4913C98.3352 47.2224 94.0639 42.9512 88.795 42.9512C83.5262 42.9512 79.2549 47.2224 79.2549 52.4913C79.2549 57.7602 83.5262 62.0315 88.795 62.0315Z"
        fill="white"
      />
      <path
        opacity="0.5"
        d="M179.441 55.0148C182.76 55.0148 185.45 52.3243 185.45 49.0055C185.45 45.6866 182.76 42.9961 179.441 42.9961C176.122 42.9961 173.432 45.6866 173.432 49.0055C173.432 52.3243 176.122 55.0148 179.441 55.0148Z"
        fill="white"
      />
      <path
        d="M168.348 165.819C170.445 165.819 172.144 164.119 172.144 162.023C172.144 159.926 170.445 158.227 168.348 158.227C166.251 158.227 164.552 159.926 164.552 162.023C164.552 164.119 166.251 165.819 168.348 165.819Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_225_86899"
          x1="140.5"
          y1={0}
          x2="140.5"
          y2={281}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BB5E00" />
          <stop offset={1} stopColor="#1681E1" />
        </linearGradient>
      </defs>
    </svg>
  );
}
